import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { memo } from 'react';

import { ReactComponent as IconArrowNext } from '../../../icons/icon-arrow-next.svg';
import { ReactComponent as IconArrowPrev } from '../../../icons/icon-arrow-previous.svg';
import { ReactComponent as IconForward } from '../../../icons/icon-forward.svg';
import classes from './bubbleFlowArrows.module.scss';

interface LeftRightArrowProps {
  disabled?: boolean;
  onClick?: VoidFunction;
  isTargeted: boolean;
}

export const LeftArrow: FC<LeftRightArrowProps> = memo(function LeftArrow(props) {
  return (
    <Arrow
      {...props}
      paddingClassName="px-[19px]"
      className="mr-[-22px]"
      buttonClassName="border-r border-[rgba(0,0,0,0.15)] border-solid border-l-0 border-y-0"
    >
      <IconArrowPrev className="w-4 h-4" />
    </Arrow>
  );
});

export const LeftForwardIcon: FC<LeftRightArrowProps> = memo(function LeftForwardIcon(props) {
  return (
    <Arrow {...props}>
      <IconForward className="w-4 h-4" />
    </Arrow>
  );
});

export const RightArrow: FC<LeftRightArrowProps> = memo(function RightArrow(props) {
  const { disabled, ...others } = props;
  // import { VisibilityContext } from 'react-horizontal-scrolling-menu';
  // const { isLastItemVisible } = useContext(VisibilityContext);
  return (
    <Arrow
      {...others}
      disabled={disabled /* || isLastItemVisible */}
      paddingClassName="px-[19px]"
      className="ml-[-22px]"
      buttonClassName="border-l border-[rgba(0,0,0,0.15)] border-solid border-r-0 border-y-0"
    >
      <IconArrowNext className="w-4 h-4" />
    </Arrow>
  );
});

interface ArrowProps extends LeftRightArrowProps {
  children: ReactNode;
  className?: string;
  buttonClassName?: string;
  paddingClassName?: string;
}

const Arrow: FC<ArrowProps> = memo(function Arrow(props) {
  const { children, disabled, onClick, isTargeted, className, buttonClassName, paddingClassName } =
    props;
  return onClick ? (
    <div
      className={classNames(
        'flex items-center z-[1]',
        isTargeted ? 'bg-gray-lightest' : 'bg-white',
        disabled ? 'opacity-0 pointer-events-none' : undefined,
        className,
      )}
    >
      <button
        disabled={disabled}
        onClick={onClick}
        className={classNames(
          'flex flex-col justify-center items-center mb-2 cursor-pointer select-none mt-5 h-10',
          classes.iconArrow,
          paddingClassName || 'px-2',
          buttonClassName,
        )}
      >
        {children}
      </button>
    </div>
  ) : (
    <div
      className={classNames(
        'flex flex-col justify-center items-center mb-2 cursor-pointer select-none mt-5 z-[1] px-2 no-hover',
        classes.noHover,
        classes.iconArrow,
        className,
        buttonClassName,
      )}
    >
      {children}
    </div>
  );
});
